import { IUpdateOrderIntV2FilterSuccessAction } from '../../actions/order-tracker-int-uplift/load-search-order-int-new';
import { IOrderTrackerState } from '../../state';

export const updateOrderIntV2SuccessReducer = (state: IOrderTrackerState, action: IUpdateOrderIntV2FilterSuccessAction) => {
    const updatedOrdersFilters = (action as IUpdateOrderIntV2FilterSuccessAction).data.orders.filters;
    const updatedOrdersOriginal = (action as IUpdateOrderIntV2FilterSuccessAction).data.orders.original;
    const updatedSearchString = (action as IUpdateOrderIntV2FilterSuccessAction).data.orders.searchString;
    const isInternationalUser = (action as IUpdateOrderIntV2FilterSuccessAction).data.orders.isInternational;

    return ({
        ...state,
        orderSearchV2: {
            ...state.orderSearchV2,
            orders: {
                ...state.orderSearchV2.orders,
                searchString: updatedSearchString !== undefined ? updatedSearchString :
                    state.orderSearchV2.orders.searchString,
                filters: updatedOrdersFilters !== undefined ? updatedOrdersFilters : state.orderSearchV2.orders.filters,
                original: updatedOrdersOriginal !== undefined ? updatedOrdersOriginal : state.orderSearchV2.orders.original,
                isInternational: isInternationalUser
            }
        }
    })
};
